import { createContext, useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type DiscussionFiltersContextType = {
  tagFilter?: string;
  setTagFilter: (tagFilter: string) => void;
};

const STUB = (...args: any) => {};
const DiscussionFiltersContext = createContext<DiscussionFiltersContextType>({
  tagFilter: undefined,
  setTagFilter: STUB
});

export const DiscussionFiltersProvider: React.FC = ({ children }) => {
  const [tagFilter, setTagFilter] = useState<string>('');
  const [search] = useSearchParams();
  const urlTag = search.get('tag');

  useEffect(() => {
    if (urlTag) {
      setTagFilter(urlTag);
      console.log(urlTag, 'urlTag');
    }
  }, [urlTag]);

  return (
    <DiscussionFiltersContext.Provider value={{
      tagFilter,
      setTagFilter
    }}>
      {children}
    </DiscussionFiltersContext.Provider>
  );
}

export const useDiscussionFilters = () => useContext(DiscussionFiltersContext);